import React from 'react';
import { modules } from '../data/modules';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
export function SystemSection() {
  return <section className="border-y border-sage/30 bg-cream-dark px-4 py-8" data-id="element-141" data-mp="3bimytjnh9f82">
      <div className="mx-auto max-w-4xl" data-id="element-142" data-mp="3bkpxes2p4goe">
        <p className="text-center font-display text-[11px] font-bold uppercase tracking-[0.14em] text-terracotta sm:text-xs" data-id="element-143" data-mp="36kldes2kx3tf">
          La soluzione che stavi cercando
        </p>
        <h2 className="mt-1.5 text-center font-display text-2xl font-black uppercase leading-tight sm:text-3xl" data-id="element-144" data-mp="2wu8v76i8lmqg">
          Un sistema professionale completo 6-in-1 per logopedisti
        </h2>

        <div className="mx-auto mt-3 max-w-2xl space-y-1 text-center text-[15px] leading-snug text-graphite sm:text-base" data-id="element-145" data-mp="2ntkicf4kxsf5">
          <p className="font-display text-lg font-black uppercase text-petrol sm:text-xl" data-id="element-146" data-mp="2iuhdovsiho7p">
            LOGOPEDIA PRO™
          </p>
          <p data-id="element-147" data-mp="2dvo61jzworfg">Più di una raccolta di schede.</p>
          <p data-id="element-148" data-mp="13zhph2l2v3y9">Più di una semplice libreria di attività.</p>
          <p data-id="element-149" data-mp="13xwwhheevt2i">
            LOGOPEDIA PRO™ è un sistema professionale creato per aiutarti a valutare, pianificare,
            organizzare e preparare il tuo lavoro con materiale strutturato e pronto all'uso.
          </p>
          <p className="font-semibold text-petrol" data-id="element-150" data-mp="tz7bvgv4ruik">Tu mantieni sempre il controllo professionale.</p>
          <p data-id="element-151" data-mp="yxsgdshf10ct">
            Il sistema ti aiuta a ridurre tutto il lavoro di preparazione che puoi evitare.
          </p>
        </div>

        <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-152" data-mp="1rp2bxvgfwjca">
          {modules.map(module => <li key={module.num} className="h-full" data-id="element-153" data-mp="1cs1k7ry90odt">
              <a href={OFFER_ANCHOR} className="flex h-full gap-3 rounded-xl border border-sage/40 bg-white p-4 transition-colors duration-150 ease-out hover:border-petrol" data-id="element-154" data-mp="1ctma349mbj5c">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-petrol font-display text-xs font-extrabold text-cream" data-id="element-155" data-mp="6bg0cfhezlic">
                  {module.num}
                </span>
                <div data-id="element-156" data-mp="23za3ktthvq78">
                  <h3 className="font-display text-[13px] font-extrabold uppercase leading-tight sm:text-[15px]" data-id="element-157" data-mp="23yrzxc4i69pa">
                    {module.title}
                  </h3>
                  <div className="mt-1 space-y-1 text-[13px] leading-snug text-graphite sm:text-sm" data-id="element-158" data-mp="1u9i4bmaga8wf">
                    {module.lines.map(line => <p key={line} data-id="element-159" data-mp="1pboyiud27gwo">{line}</p>)}
                  </div>
                </div>
              </a>
            </li>)}
        </ul>

        <a href={OFFER_ANCHOR} className="mt-5 block" aria-label="Vai all'offerta" data-id="element-160" data-mp="1g8nwb4rbe9ya">
          <img src={PRODUCT_IMG} alt="I 6 moduli di LOGOPEDIA PRO™ con i 5 bonus inclusi" className="mx-auto w-full max-w-lg transition-transform duration-200 ease-out hover:scale-[1.01]" data-id="element-161" data-mp="1baw2g5740drg" />
        </a>

        <CTAButton className="mx-auto mt-3 max-w-lg" data-id="element-162" data-mp="35p6s2fvj3bya" />
      </div>
    </section>;
}